import { render, staticRenderFns } from "./sold-stamp.vue?vue&type=template&id=a78cbfcc&scoped=true&"
import script from "./sold-stamp.vue?vue&type=script&lang=js&"
export * from "./sold-stamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78cbfcc",
  null
  
)

export default component.exports